import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	menuLabel: {
		id: 'inactive-plans-directory-base.plans-table.body.cells.trash-actions-cell.menu-label',
		defaultMessage: 'More',
		description: 'Dropdown button label for actions button in trash plans table',
	},
	actionRestorePlan: {
		id: 'inactive-plans-directory-base.plans-table.body.cells.trash-actions-cell.action-restore-plan',
		defaultMessage: 'Restore',
		description: 'Menu item text for unarchive action in trash plans table',
	},
	actionDeletePermanentlyPlan: {
		id: 'inactive-plans-directory-base.plans-table.body.cells.trash-actions-cell.action-delete-permanently-plan',
		defaultMessage: 'Delete permanently',
		description: 'Menu item text for permanent delete action in trash plans table',
	},
	planRestoringFlagError: {
		id: 'inactive-plans-directory-base.plans-table.body.cells.trash-actions-cell.plan-restoring-flag-error',
		defaultMessage: "We couldn't restore your plan. Try again.",
		description:
			'Message to be shown in the flag when the plan was not restored from the archive due to an error.',
	},
	restoreSuccessMessageTitle: {
		id: 'inactive-plans-directory-base.plans-table.body.cells.trash-actions-cell.restore-success-message-title',
		defaultMessage: 'Plan restored successfully',
		description: 'Title for success message when plan is restored',
	},
});
